const useFormatDateUtils = () => {
    function formatToBrazilianShortDateTime(dateString: Date): Promise<string> {
        const date = new Date(dateString?.toString().replace('Z',''));
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
        //@ts-ignore
        return date.toLocaleString('pt-BR', options);
    }

    function formatToBrazilianShortDate(dateString: Date): Promise<string> {
        const date = new Date(dateString?.toString().replace('Z',''));
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        //@ts-ignore
        return date.toLocaleString('pt-BR', options);
    }

    return{
        formatToBrazilianShortDateTime,
        formatToBrazilianShortDate
    }
}
export default useFormatDateUtils;